import React from "react";
import Page404 from "../../components/Page404";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <>
      <div id="main">
        <Page404 />
      </div>
    </>
  );
};
